package com.arena_web.data.dto

/**
 * Anonymous shell left behind after `DELETE /v1/users/me`.
 *
 * The backend rewrites `username` to `deleted_<uuid-no-dashes>` and `fullName`
 * to "Deleted Account" so the row keeps satisfying its unique indices and
 * a brand-new user can register with the original email. Frontend uses these
 * markers to: (a) display "Deleted Account" instead of the disposable
 * username, (b) block navigation to the now-empty profile.
 */
object DeletedAccount {
    const val DISPLAY_NAME = "Deleted Account"
    const val USERNAME_PREFIX = "deleted_"

    fun matches(username: String?, fullName: String?): Boolean {
        if (fullName == DISPLAY_NAME) return true
        if (username?.startsWith(USERNAME_PREFIX) == true) return true
        return false
    }
}

fun UserDto.isDeletedAccount(): Boolean =
    DeletedAccount.matches(username, fullName)

fun PersonDto.isDeletedAccount(): Boolean =
    DeletedAccount.matches(username, fullName)

fun FollowUserDto.isDeletedAccount(): Boolean =
    DeletedAccount.matches(username, fullName)
